/** Ort eines Termins in einer Karten-App öffnen. iPhone/iPad: Apple Karten, sonst Google Maps (öffnet am Handy die App). */
export type MapLink = { label: string; href: string };

export function isAppleDevice(userAgent = navigator.userAgent, platform = navigator.platform, touchPoints = navigator.maxTouchPoints): boolean {
  return /iPhone|iPad|iPod|Macintosh/.test(userAgent) || (platform === "MacIntel" && touchPoints > 1);
}

/** Primärer Link (passend zum Gerät) und die Alternative; null, wenn kein sinnvoller Ort vorliegt. */
export function mapLinks(location: string | null | undefined, apple = isAppleDevice()): { primary: MapLink; alternative: MapLink } | null {
  const place = location?.replace(/\s+/g, " ").trim();
  if (!place || place.length < 3) return null;
  const q = encodeURIComponent(place);
  const appleLink = { label: "Apple Karten", href: `https://maps.apple.com/?q=${q}` };
  const googleLink = { label: "Google Maps", href: `https://www.google.com/maps/search/?api=1&query=${q}` };
  return apple ? { primary: appleLink, alternative: googleLink } : { primary: googleLink, alternative: appleLink };
}

/** Zerlegt Text in Abschnitte und https-Links (für anklickbare Links in Notizen, ohne HTML einzuschleusen). */
export function linkParts(text: string): { text: string; href?: string }[] {
  const parts: { text: string; href?: string }[] = [];
  let last = 0;
  for (const m of text.matchAll(/https:\/\/[^\s<>"]+/g)) {
    if (m.index! > last) parts.push({ text: text.slice(last, m.index) });
    const url = m[0].replace(/[.,;:)]+$/, "");
    parts.push({ text: url, href: url });
    last = m.index! + url.length;
  }
  if (last < text.length) parts.push({ text: text.slice(last) });
  return parts;
}
